import { useCallback, useEffect, useState } from "react";
import { getDashboardList } from "../../services/dashboardService";

const useEState = () => {
  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await getDashboardList();
    if (res.data.code === "0000") {
      const { objectValue } = res.data;
      setData(objectValue);
    }
  }, [setData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data];
};

export default useEState;
